export const FAQ_DATA = [
  {
    category: 'Cadastro',
    slug: 'cadastro',
    questions: [
      {
        title: 'O que é o Clube Leroy?',
        text: `O Clube Leroy é o programa de fidelidade da Leroy Merlin. Ao participar,
        você acumula pontos em compras elegíveis e aproveita benefícios exclusivos,
        como cashback, Preço Clube, ofertas personalizadas e campanhas especiais.`
      },
      {
        title: 'Quem pode participar do Clube Leroy?',
        text: `Podem participar pessoas físicas maiores de 18 anos, com CPF válido.
        Algumas categorias do programa possuem critérios específicos de elegibilidade.`
      },
      {
        title: 'Como faço meu cadastro?',
        text: `Você pode se cadastrar pelo site, aplicativo, lojas físicas ou por convite
        enviado pela Leroy Merlin.`
      },
      {
        title: 'Preciso pagar para participar?',
        text: 'Não. A participação no Clube Leroy é gratuita.'
      },
      {
        title: 'Recebi um convite para participar. O que preciso fazer?',
        text: `Basta concluir seu cadastro pelos canais informados no convite. Caso o
        cadastro não seja finalizado dentro do prazo informado, será necessário
        realizar um novo cadastro ou receber um novo convite.`
      },
      {
        title: 'Posso ter mais de um cadastro?',
        text: 'Não. Cada CPF pode possuir apenas um cadastro ativo no Clube Leroy.'
      },
      {
        title: 'Como atualizo meus dados cadastrais?',
        text: `Você pode atualizar suas informações acessando sua conta no site ou
        aplicativo da Leroy Merlin, ou pelos canais oficiais de atendimento.`
      }
    ]
  },
  {
    category: 'Pontos',
    slug: 'pontos',
    questions: [
      {
        title: 'Como acumulo pontos?',
        text: `Basta informar seu CPF antes da conclusão da compra. Nas compras
        elegíveis, cada R$ 1,00 gasto equivale a 1 ponto.`
      },
      {
        title: 'Preciso informar meu CPF em todas as compras?',
        text: `Sim. A identificação do CPF é necessária para acumular pontos e
        utilizar os benefícios do programa.`
      },
      {
        title: 'Posso informar meu CPF depois que a compra foi finalizada?',
        text: 'Não. O CPF deve ser informado antes da conclusão da compra.'
      },
      {
        title: 'Todos os produtos geram pontos?',
        text: `A maioria dos produtos comercializados pela Leroy Merlin gera pontos.
        Alguns produtos, serviços ou operações podem não ser elegíveis. Consulte o
        Regulamento do Clube Leroy para conhecer as exceções.`
      },
      {
        title: 'Existe valor mínimo para acumular pontos?',
        text: 'Não. Todas as compras elegíveis geram pontos conforme as regras do programa.'
      },
      {
        title: 'Como consulto meu saldo de pontos?',
        text: `Você pode consultar seu saldo na área do Clube Leroy, disponível no site
        e no aplicativo.`
      },
      {
        title: 'Meus pontos expiram?',
        text: `Sim. Os pontos possuem validade. Sempre que você realizar uma nova
        compra elegível antes do vencimento, seu saldo disponível terá a validade
        renovada automaticamente.`
      }
    ]
  },
  {
    category: 'Cashback',
    slug: 'cashback',
    questions: [
      {
        title: 'Como transformo meus pontos em cashback?',
        text: `Você pode resgatar seus pontos pelos canais disponibilizados pela Leroy
        Merlin. Atualmente, a conversão é de 500 pontos para R$ 5,00 em cashback.`
      },
      {
        title: 'Como utilizo meu cashback?',
        text: `Basta informar seu CPF no momento da compra. O cashback será aplicado
        automaticamente como desconto nas compras elegíveis.`
      },
      {
        title: 'Posso utilizar apenas parte do meu cashback?',
        text: `Sim. O saldo restante continuará disponível até a data original de
        vencimento.`
      },
      {
        title: 'O cashback possui validade?',
        text: `Sim. Após o resgate, o cashback poderá ser utilizado até o último dia
        do mês seguinte.`
      },
      {
        title: 'Posso utilizar cashback junto com outras promoções?',
        text: `Sempre que permitido pelas regras da campanha, o cashback poderá ser
        utilizado juntamente com outros descontos e benefícios.`
      },
      {
        title: 'O cashback pode ser convertido em dinheiro?',
        text: `Não. O cashback é um benefício exclusivo do Clube Leroy e pode ser
        utilizado apenas como desconto em compras elegíveis.`
      },
      {
        title:
          'O que acontece com meus pontos ou cashback se eu devolver um produto?',
        text: `Em caso de troca, devolução ou cancelamento da compra, os pontos e
        benefícios concedidos poderão ser estornados, conforme as regras do programa.`
      }
    ]
  },
  {
    category: 'Benefícios',
    slug: 'beneficios',
    questions: [
      {
        title: 'O que é o Preço Clube?',
        text: `O Preço Clube é um benefício exclusivo para participantes do programa.
        Basta informar seu CPF para aproveitar automaticamente os preços participantes.`
      },
      {
        title: 'Preciso ativar cupons para receber os descontos?',
        text: `Não. Os benefícios do Preço Clube são aplicados automaticamente nas
        compras elegíveis.`
      },
      {
        title: 'Quais benefícios fazem parte do Clube Leroy?',
        text: `Além do acúmulo de pontos e cashback, o programa oferece Preço Clube,
        ofertas exclusivas, campanhas promocionais, benefícios de aniversário,
        benefício de boas-vindas e outras vantagens.`
      },
      {
        title: 'O que é o benefício de boas-vindas?',
        text: `Novos participantes elegíveis poderão receber um benefício de
        boas-vindas, conforme as condições vigentes divulgadas pela Leroy Merlin.`
      },
      {
        title: 'Como funciona o benefício de aniversário?',
        text: `Os participantes poderão receber benefícios especiais durante o mês
        do seu aniversário, de acordo com as campanhas vigentes.`
      }
    ]
  },
  {
    category: 'Categorias Especiais',
    slug: 'categorias-especiais',
    questions: [
      {
        title: 'O que é o Clube Leroy PRO?',
        text: `É a categoria destinada aos profissionais da construção civil
        elegíveis, que oferece benefícios exclusivos conforme as regras do programa.`
      },
      {
        title: 'O que é o Clube Leroy EAD?',
        text: `É a categoria destinada a engenheiros, arquitetos e designers de
        interiores que atendam aos critérios de elegibilidade definidos pela Leroy
        Merlin.`
      },
      {
        title:
          'Sou profissional da construção. Como faço para participar do Clube Leroy PRO?',
        text: `Caso você atenda aos critérios estabelecidos pela Leroy Merlin,
        poderá ser convidado ou aprovado para participar da categoria PRO.`
      }
    ]
  },
  {
    category: 'Regras Gerais',
    slug: 'regras-gerais',
    questions: [
      {
        title: 'Posso cancelar minha participação no Clube Leroy?',
        text: 'Sim. O cancelamento pode ser solicitado pelos canais oficiais da Leroy Merlin.'
      },
      {
        title: 'O que acontece quando cancelo minha participação?',
        text: `Ao cancelar sua participação, os pontos, cashback e demais benefícios
        vinculados ao programa serão cancelados.`
      },
      {
        title: 'As regras e benefícios do Clube Leroy podem mudar?',
        text: `Sim. A Leroy Merlin poderá atualizar benefícios, campanhas e regras
        operacionais do programa sempre que necessário, respeitando a legislação
        vigente.`
      },
      {
        title: 'Onde encontro o regulamento completo?',
        text: `O Regulamento Completo do Clube Leroy está disponível nos canais
        oficiais da Leroy Merlin e reúne todas as regras de participação, benefícios
        e condições do programa.`
      }
    ]
  }
]
